module.exports = __webpack_public_path__ + "static/media/id3.049a8d36.png";